import { render } from "./OrderConfirmationPage.vue?vue&type=template&id=63655e37"
import script from "./OrderConfirmationPage.vue?vue&type=script&lang=js"
export * from "./OrderConfirmationPage.vue?vue&type=script&lang=js"

import "./OrderConfirmationPage.vue?vue&type=style&index=0&id=63655e37&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__